// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.photos.RentalManagerUserPropertyFloorPlanPhotoWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args
>;

/**
 * Upload a photo for a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
